import { MOBILE_APPS } from "./catalog";
import { fetchAndroidAppInfo } from "./fetch-android";
import { fetchIosAppInfo } from "./fetch-ios";
import { CheckedMobileApp } from "./types";

export async function checkMobileApps(): Promise<CheckedMobileApp[]> {
  return Promise.all(
    MOBILE_APPS.map(async (app) => {
      const [ios, android] = await Promise.all([
        app.iosBundleId
          ? fetchIosAppInfo(app.iosBundleId)
          : Promise.resolve(undefined),
        app.androidPackageId
          ? fetchAndroidAppInfo(app.androidPackageId)
          : Promise.resolve(undefined),
      ]);

      return {
        id: app.id,
        name: app.name,
        ios,
        android,
      };
    }),
  );
}
